import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import Ranking from './components/Ranking';
import Index from './components/Index';
import Updates from './components/Updates';
import Contact from './components/Contact';
import Media from './components/Media';
import Topics from './components/Topics';
import AppSection from './components/AppSection';
import Comments from './components/Comments';
import Cards from './components/Cards';
import FAQ from './components/FAQ';
import Carousel from './components/Carousel';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <About />
        <Ranking />
        <Index />
        <Updates />
        <Contact />
        <Media />
        <Topics />
        <AppSection />
        <Comments />
        <Cards />
        <FAQ />
        <Carousel />
      </main>
      <Footer />
    </>
  );
}